import { useState } from "react";
import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import Select from "react-select";
import { OptionImage } from "../../product/style";

const ModuleColorsDialog = ({
  orderItem,
  tableManager,
  moduleColorIdentifiers,
  updateModuleProperties,
  toggleClearOverrideModal,
  setClearOverrideFunc,
  clearModuleOverrides,
  mutateCurrentRoom,
  setCurrentTab,
  access,
}) => {
  const [addPropertyList, setAddPropertyList] = useState([]);
  const [showAddProperty, setShowAddProperty] = useState(true);

  // FILTER valid color properties that can be added
  const filteredProperties = orderItem.property_list;

  // GROUP by level
  const groupedOptions = [
    {
      label: "Module",
      options: filteredProperties
        .filter((prop) => prop.level === "module")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
  ];

  const formatGroupLabel = (data) => (
    <>
      <div
        style={{
          padding: "0px",
        }}
      >
        {data.label}
      </div>
    </>
  );

  const shutterLevelColorProperties = orderItem.property_list.filter(
    (property) => property.is_shutter_level_color_property === true
  );

  const renderPropertyDropdown = (property, index, isShutterLevel = false) => {
    if (!isShutterLevel) {
      const option =
        property.options.find(
          (option) => option.selected && property.is_overridden_v2
        ) || null;

      if (!["color", "internal_color"].includes(property.identifier)) {
        if (option == null) return null;
      }

      const selectedOption = option;

      return (
        <div
          key={property.identifier || index}
          onClick={(e) => e.stopPropagation()}
        >
          {property && (
            <>
              <p className="grey_letter mb-1">{property.name}</p>
              <div className="column-gap-3 d-flex align-items-center">
                {property.is_editable ? (
                  <>
                    <Select
                      autoFocus={index === 0}
                      className="list-summary-select"
                      key={index}
                      isDisabled={!property.is_editable}
                      value={selectedOption}
                      onChange={(selectedOption) => {
                        if (selectedOption.identifier === "__add_more__") {
                          if (setCurrentTab) {
                            setCurrentTab("materials", "colors");
                          } else {
                            tableManager.clear();
                          }
                          return;
                        }
                        property.is_overridden_v2 = true;
                        property.options.forEach((o) => {
                          o.selected =
                            o.identifier === selectedOption.identifier;
                        });
                        mutateCurrentRoom();
                        updateModuleProperties({
                          id: orderItem.id,
                          propIdentifier: property.uniq_id,
                          optionIdentifier: selectedOption.identifier,
                        });
                      }}
                      options={[
                        ...property.options.map((option, optionIndex) => {
                          option.value = option.name;
                          option.label = (
                            <div key={optionIndex}>
                              {option.image && (
                                <OptionImage
                                  src={option.image}
                                  alt={option.name}
                                  className="border border-dark rounded-circle me-2"
                                />
                              )}
                              {option.name}
                            </div>
                          );
                          option.isDisabled =
                            option.settings_disabled === true ||
                            option.settings_disabled === "true";
                          option.key = index;
                          return {
                            value: option.name,
                            label: option.name,
                            ...option,
                          };
                        }),
                        {
                          value: "... add more colors",
                          label: "... add more colors",
                          identifier: "__add_more__",
                          key: `add-more-colors-${index}`,
                        },
                      ]}
                    />
                    {property.is_overridden_v2 &&
                      property.is_clearable &&
                      property.is_editable && (
                        <i
                          className="fa-regular fa-trash-can fs-6 pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleClearOverrideModal();
                            setClearOverrideFunc(() => () => {
                              property.value_name = property.project_value_name;
                              property.is_overridden_v2 = false;
                              clearModuleOverrides({
                                id: orderItem.id,
                                propIdentifier: property.uniq_id,
                              });
                            });
                          }}
                        />
                      )}
                  </>
                ) : (
                  property &&
                  property.is_overridden_v2 && (
                    <div className="mt-1 text-disabled">
                      {property.options.find((option) => option.selected)
                        ?.name || "No Value"}
                    </div>
                  )
                )}
              </div>
            </>
          )}

          {property && !property.is_overridden_v2 && (
            <p className="m-0 grey_letter mt-2">{`Using ${property.value_name}`}</p>
          )}
        </div>
      );
    }

    const mappedOptions =
      property.options?.map((option, optionIndex) => {
        const mappedOption = {
          value: option.name,
          label: option.name,
          ...option,
        };
        mappedOption.label = (
          <div key={optionIndex}>
            {option.image && (
              <OptionImage
                src={option.image}
                alt={option.name}
                className="border border-dark rounded-circle me-2"
              />
            )}
            {option.name}
          </div>
        );
        mappedOption.isDisabled =
          option.settings_disabled === true ||
          option.settings_disabled === "true";
        mappedOption.key = index;
        return mappedOption;
      }) || [];

    const isOverridden =
      property.is_overridden_v2 || property.is_shutter_override;
    const selectedOption = isOverridden
      ? mappedOptions.find((option) => {
          const originalSelected = property.options?.find((o) => o.selected);
          return (
            originalSelected &&
            option.identifier === originalSelected.identifier
          );
        }) || null
      : null;

    return (
      <div
        key={property.identifier || index}
        onClick={(e) => e.stopPropagation()}
      >
        {property && (
          <>
            <p className="grey_letter mb-1">
              {isShutterLevel ? `Shutter ${property.name}` : property.name}
            </p>
            <div className="column-gap-3 d-flex align-items-center">
              <Select
                className="list-summary-select"
                key={`${property.identifier}-${property.is_overridden_v2}-${
                  property.is_shutter_override
                }-${selectedOption?.identifier || "none"}`}
                isDisabled={false}
                value={selectedOption}
                placeholder="Select"
                onChange={(selectedOption) => {
                  if (selectedOption.identifier === "__add_more__") {
                    if (setCurrentTab) {
                      setCurrentTab("materials", "colors");
                    } else {
                      tableManager.clear();
                    }
                    return;
                  }
                  property.is_overridden_v2 = true;
                  if (property.is_shutter_level_color_property) {
                    property.is_shutter_override = true;
                  }
                  property.options.forEach((o) => {
                    o.selected = o.identifier === selectedOption.identifier;
                  });
                  mutateCurrentRoom();
                  updateModuleProperties({
                    id: orderItem.id,
                    propIdentifier: property.uniq_id,
                    optionIdentifier: selectedOption.identifier,
                  });
                }}
                options={[
                  ...mappedOptions,
                  {
                    value: "... add more colors",
                    label: "... add more colors",
                    identifier: "__add_more__",
                    key: `add-more-colors-shutter-${index}`,
                  },
                ]}
              />
              {(property.is_overridden_v2 || property.is_shutter_override) && (
                <i
                  className="fa-regular fa-trash-can fs-6 pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleClearOverrideModal();
                    setClearOverrideFunc(() => () => {
                      property.value_name = property.project_value_name;
                      property.is_overridden_v2 = false;
                      property.is_shutter_override = false;
                      clearModuleOverrides({
                        id: orderItem.id,
                        propIdentifier: property.uniq_id,
                      });
                    });
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {moduleColorIdentifiers.map((identifier, index) => {
          const property = orderItem.property_list.find(
            (e) => e.identifier === identifier
          );

          if (!property) return null;

          return renderPropertyDropdown(property, index, false);
        })}

        {shutterLevelColorProperties.map((property, index) => {
          return renderPropertyDropdown(
            property,
            moduleColorIdentifiers.length + index,
            true
          );
        })}
      </div>
      {addPropertyList.length > 0 && (
        <div className="mt-3 d-flex flex-column row-gap-3">
          {addPropertyList.map((identifier, index) => {
            const property = orderItem.property_list.find(
              (e) => e.identifier === identifier
            );

            return (
              <div key={index}>
                <p className="grey_letter mb-1">{property.name}</p>
                {property.is_editable ? (
                  <Select
                    className="list-summary-select"
                    value={null}
                    isDisabled={!property.is_editable}
                    onChange={(selectedOption) => {
                      property.is_overridden_v2 = true;
                      property.options.forEach((o) => {
                        o.selected = o.identifier == selectedOption.value;
                      });
                      property.highlight = true;
                      setAddPropertyList(
                        addPropertyList.filter((e) => e !== identifier)
                      );
                      setShowAddProperty(true);
                      updateModuleProperties({
                        id: orderItem.id,
                        propIdentifier: property.uniq_id,
                        optionIdentifier: selectedOption.value,
                      });
                    }}
                    options={property.options.map((option) => ({
                      label: option.name,
                      value: option.identifier,
                      isDisabled:
                        option.settings_disabled === true ||
                        option.settings_disabled === "true",
                    }))}
                  />
                ) : (
                  <div className="mt-1 text-disabled">
                    {property.options.find((option) => option.selected)?.name ||
                      "No Value"}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div className={`${addPropertyList.length === 0 ? "mt-3" : ""}`}>
        {showAddProperty && addPropertyList.length === 0 ? (
          <div
            className="d-flex align-items-center column-gap-2 active-dimension pointer"
            onClick={(e) => {
              setShowAddProperty(false);
              e.stopPropagation();
            }}
          >
            <i className="fa-solid fa-plus" />
            <p className="m-0">Add Property</p>
          </div>
        ) : (
          addPropertyList.length === 0 && (
            <div className="d-flex align-items-center column-gap-2 position-relative">
              <Select
                placeholder={"Select Property"}
                className="list-summary-select"
                defaultValue={null}
                menuPosition="absolute"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                isDisabled={!access.customize_section || orderItem.is_filler}
                options={groupedOptions}
                formatGroupLabel={formatGroupLabel}
                onChange={(selectedOption) => {
                  setAddPropertyList([
                    ...addPropertyList,
                    selectedOption.value,
                  ]);
                  setShowAddProperty(true);
                }}
              />
              <p
                className="m-0 active-dimension pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAddProperty(true);
                }}
              >
                Cancel
              </p>
            </div>
          )
        )}
      </div>
      <TableDialogFooter>
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
          className="mt-3"
        >
          Done
        </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default ModuleColorsDialog;
